// src/pages/usa/puertorico/Jayuya.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Jayuya ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Jayuya() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Jayuya, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Jayuya, Puerto Rico</h2>

            <p>
              Jayuya is located in the central mountainous region of Puerto Rico,
              celebrated for its rich indigenous heritage and breathtaking natural
              landscapes. Although Jayuya is inland, it offers a wealth of unique
              experiences. Sitting at an altitude of approximately 1,200 feet (366
              meters) above sea level, the town enjoys a cooler climate compared to
              Puerto Rico’s coastal areas. From charming restaurants, coffee farms,
              and local shops to cultural landmarks and natural wonders, Jayuya
              invites visitors to explore the heart of Puerto Rico.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              To reach Jayuya, you can drive from San Juan in approximately 1.5 to 2
              hours, depending on traffic. The most common route is via PR‑22 west
              from San Juan, then PR‑10 south toward Utuado, followed by PR‑123 east
              into Jayuya. Roads are generally well‑maintained, though you can expect
              some winding mountain stretches as you near the town. If you are
              arriving at Rafael Hernández Airport (BQN) in Aguadilla, the drive to
              Jayuya takes about 2.5 to 3 hours heading southeast via PR‑2 and PR‑10.
            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Aerostatic Balloon:</strong> One of the unique attractions in
                  Jayuya is the Aerostatic Balloon, which offers breathtaking views of
                  the surrounding mountains and valleys. Rides are typically available
                  on weekends and holidays, providing a serene and picturesque
                  experience.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.24274792857904,-66.57368977458117"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Piedra Escrita:</strong> Piedra Escrita is an ancient rock art
                  site featuring Taíno petroglyphs along the Río Caguana. It offers a
                  fascinating glimpse into Puerto Rico’s indigenous heritage. If you
                  enjoy history and archaeological sites, this is a must‑visit—and you
                  can also take a refreshing swim in the nearby river.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.217360709358225,-66.57316842502998"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>El Cemí Museum:</strong> This museum showcases Taíno culture
                  and artifacts, including replicas of cemís (Taíno deities). It’s an
                  educational stop that provides context to the indigenous history of
                  Puerto Rico.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.20951075900848,-66.56157487643421"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>🥾 Other Hidden Gems</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Puente Peatonal Río Jayuya:</strong> This colorful pedestrian
                  bridge spans the Río Jayuya and adds a vibrant touch to the town’s
                  landscape. It’s a great spot for photos and a peaceful stroll through
                  the heart of Jayuya.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.218117445505225,-66.59216849591135"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>
                    Busto del Cacique Hayuya y Tumba del Indio:
                  </strong>{" "}
                  This monument honors the Taíno leader Hayuya and features a symbolic
                  tomb. It’s a meaningful stop for those interested in Puerto Rico’s
                  indigenous legacy.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.2188,-66.5913"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Café Tres Picachos:</strong> Nestled in the mountains of
                  Jayuya, this coffee farm offers a rich experience—from learning about
                  the coffee‑making process to tasting freshly brewed local blends.
                  Surrounded by lush greenery, it’s a perfect stop for nature and coffee
                  lovers alike.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.189248688069334,-66.56195206524349"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>🛏️ Places to Stay in Jayuya</h3>

            <p>
              While I usually just pass through Jayuya on day trips, here are some
              well‑rated spots if you are planning to stay overnight. This was updated
              November 2025—verify with Booking.com or Expedia for the latest reviews
              and availability.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Antique Mountain Cabin:</strong> A rustic, peaceful retreat
                  nestled in the hills of Jayuya. Guests love the panoramic views, cozy
                  interiors, and proximity to hiking trails and waterfalls.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Café Tres Picachos Guesthouse:</strong> Located near the coffee
                  farm, this guesthouse offers a tranquil stay surrounded by nature.
                  Ideal for coffee lovers and those seeking a quiet escape.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Jayuya Vacation Rentals:</strong> A selection of private homes
                  and cabins available for short‑term stays. Many feature mountain views,
                  outdoor terraces, and full kitchens—great for families or small groups.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Nearby Option – Hilton Ponce Golf & Casino Resort:</strong>{" "}
                  Though not in Jayuya, this upscale resort in Ponce (about 1.5 hours
                  away) is a popular base for exploring Puerto Rico’s central region. It
                  includes pools, restaurants, and ocean views.
                </div>
              </li>
            </ul>

           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I filmed in Jayuya. Be sure to set the quality to
              1080p or higher. Hope you enjoy them!
            </p>

            <p>
              <a
                href="https://youtu.be/0rpEhOKpw3Q?si=pImKwQI1pzSxqI-s"
                target="_blank"
                rel="noopener noreferrer"
              >
                Aerostatic Balloon
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/HguoIJCIG1o?si=gpq20WYwvVH0pVSo"
                target="_blank"
                rel="noopener noreferrer"
              >
                Piedra Escrita
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/FefRYPyzp7w?si=bQN6seUdqUNp3zFw"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bridge and Plaza
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/xEM6_j0NmBU?si=lKux1SSA3wuUCbb1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Museum El Cemí
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/eAPIhYQ2jcg?si=JNGUE7qqbjCsUaCU"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stairs
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/j_FgZFwSOs8?si=j9q597m6bDLBLUr-"
                target="_blank"
                rel="noopener noreferrer"
              >
                Hacienda Tres Picachos
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/0rpEhOKpw3Q?si=pImKwQI1pzSxqI-s"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/jayuya/balloon.jpg"
                alt="Aerostatic Balloon in Jayuya"
              />
            </a>

            <a
              href="https://youtu.be/HguoIJCIG1o?si=gpq20WYwvVH0pVSo"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/jayuya/piedraescrita.jpg"
                alt="Piedra Escrita in Jayuya"
              />
            </a>

            <a
              href="https://youtu.be/FefRYPyzp7w?si=bQN6seUdqUNp3zFw"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/jayuya/bridge.jpg"
                alt="Bridge in Jayuya"
              />
            </a>

            <a
              href="https://youtu.be/xEM6_j0NmBU?si=lKux1SSA3wuUCbb1"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/jayuya/cemi.jpg"
                alt="Museo El Cemí"
              />
            </a>

            <a
              href="https://youtu.be/eAPIhYQ2jcg?si=JNGUE7qqbjCsUaCU"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/jayuya/stairs.jpg"
                alt="Stairs in Jayuya"
              />
            </a>

            <img
              src="/images/usa/puertorico/jayuya/plaza.jpg"
              alt="Plaza of Jayuya"
            />
            <img
              src="/images/usa/puertorico/jayuya/viewfromballoon.jpg"
              alt="View from Balloon"
            />
            <img
              src="/images/usa/puertorico/jayuya/viewfromballoon2.jpg"
              alt="View from Balloon"
            />
          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
